import { useScrolled } from "@/hooks/useReveal";

export default function BackToTop() {
  const visible = useScrolled(700);

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label="Nazaj na vrh strani"
      tabIndex={visible ? 0 : -1}
      className={`fixed bottom-[84px] right-4 z-40 flex h-10 w-10 cursor-pointer items-center justify-center rounded-full border border-background-300 bg-background-50 text-foreground-800 transition-all duration-500 ease-smooth hover:border-secondary-500 hover:bg-secondary-500 hover:text-background-50 lg:bottom-8 lg:right-8 lg:h-11 lg:w-11 ${
        visible
          ? "pointer-events-auto translate-y-0 opacity-100"
          : "pointer-events-none translate-y-3 opacity-0"
      }`}
    >
      <i className="ri-arrow-up-line text-base" />
    </button>
  );
}